module.exports = __webpack_public_path__ + "static/media/lykke06.c0cd6e15.jpg";